module.exports = __webpack_public_path__ + "img/20_newYouth_wmf.5281cf17.png";